;(function () {
    function initFilters() {
        let allFilterHeadings = document.querySelectorAll('.filters__title')
        let filterForm = document.querySelector('form.filters')
        let clearFilters = document.getElementById('clear-filters')

        if (!allFilterHeadings.length || !filterForm) {
            console.warn('Filter form or headings not found')
            return
        }

        allFilterHeadings.forEach((el, index) => {
            el.addEventListener('click', function () {
                el.parentNode.classList.toggle('open')
            })
        })

        let allFilterOptions = document.querySelectorAll('.filters input')

        allFilterOptions.forEach(function (el, index) {
            el.addEventListener('change', function () {
                filterForm.submit()
            })
        })

        function initFilterButton() {
            const filterButton = document.getElementById('filter-button')
            const collectionContainer = document.querySelector(
                '.collection-container'
            )

            // console.log('Filter button:', filterButton)
            // console.log('Collection container:', collectionContainer)

            if (!filterButton || !collectionContainer) {
                console.warn('Filter button or collection container not found')
                return
            }

            filterButton.addEventListener('click', (event) => {
                event.preventDefault()
                // console.log('Filter button clicked')
                if (collectionContainer.classList.contains('no-filters')) {
                    collectionContainer.classList.remove('no-filters')
                    // console.log('Removed no-filters class')
                } else {
                    collectionContainer.classList.add('no-filters')
                    // console.log('Added no-filters class')
                }
            })

            clearFilters.addEventListener('click', function (e) {
                e.preventDefault()

                // Get the base collection URL without any parameters
                const baseUrl = window.location.pathname

                // Redirect to the base collection URL
                window.location.href = baseUrl
            })

            if (window.location.search) {
                if (collectionContainer.classList.contains('no-filters')) {
                    collectionContainer.classList.remove('no-filters')
                }
            }
        }

        initFilterButton()
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFilters)
    } else {
        initFilters()
    }
})()
